import { URLS } from './interface';

// 配置富文本框
export const NEditorConfig = {
  // serverUrl: './', // 服务器统一请求接口路径
  imageUploadFullPath: URLS.uploadImage.url, // 配置上传图片的全路径
  module: 5, //对应fileBizModule
  UEDITOR_HOME_URL: './assets/node_modules/@notadd/neditor/', // 配置neditor的代码根路径
  imageUrlPrefix: URLS.attachment.url, // 图片加载相对路径（后缀拼接文件名称），用来配置上传后的文件访问地址 ;
  // imagePathFormat: '/message/send/common/uploadImage/{filename}', // 上传保存路径,可以自定义保存路径和文件名格式，不使用本地保存，可不配置 ;
  imageActionName: 'uploadimage', // 执行上传图片的action名称 ;
  // scrawlActionName: "uploadscrawl",
  // videoActionName: "uploadvideo",
  imageFieldName: 'file', // 提交的图片表单名称 ;
  imageMaxSize: 2097152, // 上传大小限制，单位B; 默认 2M
  imageAllowFiles: ['.png', '.jpg', '.jpeg', '.gif', '.bmp'], // 上传图片格式显示 ;
  imageCompressEnable: true, // 是否压缩图片,默认是true ;
  imageCompressBorder: 600, // 图片压缩最长边限制 ;
  imageInsertAlign: 'none', // 插入的图片浮动方式 ;
  replace: '',
  initialFrameHeight: 300,
  initialFrameWidth: '100%',
  // minFrameWidth {Number} [默认值：800] //编辑器拖动时最小宽度，默认800
  // minFrameHeight {Number} [默认值：220] //编辑器拖动时最小高度，默认220
  lang: 'zh-cn',
  charset: 'utf-8',
  initialContent: '',
  // emotionLocalization {Boolean} [默认值：false] //是否开启表情本地化，默认关闭。若要开启请确保emotion文件夹下包含官网提供的images表情文件夹
  emotionLocalization: true,
  // listDefaultPaddingLeft [默认值：'30'//默认的左边缩进的基数倍
  listDefaultPaddingLeft: 30,
  // fontsize {Array} //字号 默认值:[10, 11, 12, 14, 16, 18, 20, 24, 36]
  elementPathEnabled: false, // 是否显示元素路径
  // sourceEditor {String} [默认值："codemirror"]  //源码的查看方式，codemirror是代码高亮，textarea是文本框，默认是codemirror，注意默认codemirror只能在ie8+和非ie中使用
  zIndex: 20,
  saveInterval: 3000,
  autoClearinitialContent: true,
  // 允许的最大字符数,[默认值：10000]
  maximumWords: 2000,
  // wordCountMsg: 默认：当前已输入 {#count} 个字符，您还可以输入{#leave} 个字符
  wordOverFlowMsg: '<span style="color:red">您输入的字符数已超过限制！</span>', // 默认：你输入的字符个数已经超出最大允许值，服务器可能会拒绝保存！
  allowDivTransToP: false, // {Boolean} 默认：会将外部进入的html数据中的Div标签转换成P标签，外部进入的数据包括粘贴和调用setContent接口进入编辑器的数据。如果设置成false将不在做这个转换。
  autoHeightEnabled: false,
  enableContextMenu: false,
  scaleEnabled: true,
  wordCount: true,
  webAppKey: '',
  toolbars: [
    [
      'fullscreen',
      // 'source',
      '|',
      'undo',
      'redo',
      '|',
      'bold',
      'italic',
      'underline',
      'fontborder',
      'strikethrough',
      // 'superscript',
      // 'subscript',
      // 'removeformat',
      // 'formatmatch',
      // 'autotypeset',
      'blockquote',
      // 'pasteplain',
      '|',
      'forecolor',
      'backcolor',
      'insertorderedlist',
      'insertunorderedlist',
      // 'selectall',
      'cleardoc',
      '|',
      'rowspacingtop',
      'rowspacingbottom',
      'lineheight',
      '|',
      // 'customstyle',
      // 'paragraph',
      'fontfamily',
      'fontsize',
      '|',
      // 'directionalityltr',
      // 'directionalityrtl',
      'indent',
      '|',
      'justifyleft',
      'justifycenter',
      'justifyright',
      'justifyjustify',
      '|',
      // 'touppercase',
      // 'tolowercase',
      '|',
      // 'link',
      // 'unlink',
      // 'anchor',
      '|',
      // 'imagenone',
      // 'imageleft',
      // 'imageright',
      // 'imagecenter',
      '|',
      // "simpleupload",
      'insertimage',
      // 'emotion',
      // 'scrawl',
      // 'insertvideo',
      // 'music',
      // 'attachment',
      // 'map',
      // 'gmap',
      // 'insertframe',
      '|',
      // "webapp",
      // 'pagebreak',
      // 'template',
      // 'background',
      '|',
      // 'insertcode',
      // 'horizontal',
      'date',
      'time',
      // 'spechars',
      // 'snapscreen',
      // 'wordimage',
      '|',
      // 'inserttable',
      // 'deletetable',
      // 'insertparagraphbeforetable',
      // 'insertrow',
      // 'deleterow',
      // 'insertcol',
      // 'deletecol',
      // 'mergecells',
      // 'mergeright',
      // 'mergedown',
      // 'splittocells',
      // 'splittorows',
      // 'splittocols',
      // 'charts',
      // '|',
      // 'print',
      // 'preview',
      // 'searchreplace',
      // 'drafts',
      // 'help',
    ],
  ],
};

export const NEditorPreviewConfig = {
  charset: 'utf-8',
  initialContent: '',
  zIndex: 20,
  initialFrameHeight: 300,
  initialFrameWidth: '100%',
  elementPathEnabled: false,
  scaleEnabled: false,
  autoHeightEnabled: false,
  wordCount: false,
  toolbars: [[]],
};
